import {
  whatIfInnerSelector,
  whatIfOrDefaultSelector,
} from '../../WhatIfsSelector';
import { selectedGoalSelector } from '../../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';

export const subDebtData = (state, props) => {
  const whatIf = whatIfOrDefaultSelector(state, props);
  const { DebtType } = selectedGoalSelector(state, props);
  const whatIfOptions = whatIf.Options || { DebtTypes: [] };

  return whatIfOptions.DebtTypes.find(option => option.value === DebtType) || [];
};

export const options = (state, props) => {
  const { termOptions } = subDebtData(state, props);

  return termOptions || [];
};

export const debtTitle = (state, props) => {
  const { label } = subDebtData(state, props);
  return `${label} Payoff`;
};

export const selectedRefinanceValueSelector = (state, props) => (
  whatIfInnerSelector(state, props).Term
);

export const interestRateSelector = (state, props) => (
  whatIfInnerSelector(state, props).InterestRate * 100
);
